var _path, _rect;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdits(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "02_\u7F16\u8F91") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.18,56.1H11.62A3.72,3.72,0,0,1,7.9,52.38V11.83A3.73,3.73,0,0,1,11.62,8.1H40.09a1.85,1.85,0,0,1,0,3.7H11.62l0,40.58,40.58,0,0-28.69a1.85,1.85,0,1,1,3.69,0V52.38A3.72,3.72,0,0,1,52.18,56.1Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.48,
    y: 2.96,
    width: 4,
    height: 39.12,
    rx: 2,
    transform: "translate(28.07 -22.73) rotate(45)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdits);
export default __webpack_public_path__ + "static/media/edits.7b2965d4.svg";
export { ForwardRef as ReactComponent };